export default {"src":"/_next/static/media/campusInviteWorking3.521ab272.svg","height":304,"width":811,"blurWidth":0,"blurHeight":0};